export default __webpack_public_path__ + "static/media/logo_saltala_keiron.8d64c0fb.png";